__turbopack_context__.v({
  "buttonContainer": "UserMenu-module__F2WQAG__buttonContainer",
  "userButton": "UserMenu-module__F2WQAG__userButton",
});
